import { useEffect, useState } from 'react'

/**
 * Hook to make a HEAD request to a URL
 *
 * @example
 * const [data, loading, error] = useHeadRequest('https://example.com')
 *
 * @param url - The URL to fetch
 * @returns [data, loading, error] - The data, loading state, and error
 */
export function useHeadRequest(
    url: string,
): [Response | null, boolean, Error | null] {
    const [data, setData] = useState<Response | null>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        ;(async () => {
            try {
                setLoading(true)
                const response = await fetch(url, {
                    method: 'HEAD',
                    credentials: 'same-origin',
                })
                setData(response)
            } catch (err) {
                setError(err)
            } finally {
                setLoading(false)
            }
        })()
    }, [url])

    return [data, loading, error]
}
